<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <div class="filter-container">
      <div class="filter-row">
        <div class="filter-label">ID:</div>
        <el-input
          v-model="queryParams.uid"
          placeholder="请输入ID"
          class="filter-item"
          @keyup.enter.native="handleQuery"
        />
      </div>
      <div class="filter-row">
        <div class="filter-label">用户昵称:</div>
        <el-input
          v-model="queryParams.nickName"
          placeholder="请输入用户昵称"
          class="filter-item"
          @keyup.enter.native="handleQuery"
        />
      </div>
      <div class="filter-row">
        <div class="filter-label">来源：</div>
        <el-select v-model="queryParams.relation_type" placeholder="全部" clearable style="width: 140px;"
          class="filter-item">
          <el-option v-for="item in relationOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="filter-row">
        <div class="filter-label">充值时间：</div>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="filter-item"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
        />
      </div>
      <div class="filter-row button-row">
        <el-button class="filter-item" type="primary" @click="setToday">
          今日
        </el-button>
        <el-button class="filter-item" type="primary" @click="setYesterday">
          昨日
        </el-button>
        <el-button class="filter-item" type="success" @click="setLast7Days">
          近7天
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="default"
          icon="el-icon-refresh"
          @click="resetQuery"
        >
          重置
        </el-button>
      </div>
    </div>

    <!-- 统计区域 -->
    <div class="summary-bar">
      <span class="summary-item">
        总充值金额：<span class="summary-amount">¥{{ totalMoney }}</span>
      </span>
      <span class="summary-tip">（按当前筛选条件统计）</span>
      <span class="summary-tip">注：仅「子账号邀请」来源的充值走合伙人分佣，「自己邀请」「子账号」仍走原有拉新/工会返佣</span>
    </div>

    <!-- 表格区域 -->
    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="序号" type="index" align="center" width="60" />
      <el-table-column label="ID" prop="uid" align="center" width="100" />
      <el-table-column label="用户昵称" prop="nick" align="center" />
      <el-table-column label="来源" align="center" width="110">
        <template slot-scope="{row}">
          <el-tag :type="getRelationTagType(row)" size="small">{{ getRelationLabel(row) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="头像" align="center" >
        <template slot-scope="{row}">
          <img v-if="row.avatar" :src="row.avatar" alt="头像" style="width: 50px; height: 50px; border-radius: 50%;">
          <span v-else>无头像</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile" align="center" width="130" />
      <el-table-column label="充值金额" prop="money" align="center">
        <template slot-scope="{row}">
          <span class="amount">¥{{ row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" align="center">
        <template slot-scope="{row}">
          <el-tag :type="getPayTypeTag(row.pay_type)">
            {{ getPayTypeLabel(row.pay_type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="充值时间" align="center" >
          <template slot-scope="{row}">
            <span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getAction } from '@/api/user'
import {
  RELATION_OPTIONS,
  getRelationLabel,
  getRelationTagType,
  withRelationType,
  isSuccess
} from '@/utils/agentRelation'

export default {
  name: 'CoinRechargeList',
  components: { Pagination },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      totalMoney: 0,
      listLoading: true,
      dateRange: null,
      relationOptions: RELATION_OPTIONS,
      queryParams: {
        page: 1,
        limit: 10,
        nickName: '',
        uid: '',
        relation_type: '',
        rechargeRecordType: 0, // 0是金币充值列表
        startTime: '',
        endTime: ''
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getRelationLabel,
    getRelationTagType,

    async getList() {
      this.listLoading = true
      try {
        // 构建请求参数
        const params = {
          page: this.queryParams.page,
          limit: this.queryParams.limit,
          rechargeRecordType: this.queryParams.rechargeRecordType
        }

        // 添加搜索条件
        if (this.queryParams.nickName) {
          params.nickName = this.queryParams.nickName
        }
        if (this.queryParams.uid) {
          params.uid = this.queryParams.uid
        }
        // 来源筛选：不传 = 全部（与改造前一致）
        withRelationType(params, this.queryParams.relation_type)
        if (this.queryParams.startTime) {
          params.startTime = this.queryParams.startTime + ' 00:00:00'
        }
        if (this.queryParams.endTime) {
          params.endTime = this.queryParams.endTime + ' 23:59:59'
        }
         params.status = 1

        console.log('金币充值记录请求参数:', params)
        const res = await getAction('/api/center/rechargeList', params)
        console.log('金币充值记录响应结果:', res)

        if (isSuccess(res)) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
          // 总充值金额：使用后端返回的 total_amount 字段
          const totalAmount = (res.data && res.data.total_amount) || 0
          this.totalMoney = Number(totalAmount).toFixed(2)
          console.log('金币充值记录数据加载成功:', this.list.length, '条记录, 总充值金额:', this.totalMoney)
        } else {
          this.$message.error(res.msg || '获取数据失败')
          this.list = []
          this.total = 0
          this.totalMoney = '0.00'
        }
      } catch (error) {
        console.error('获取金币充值记录失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
        this.list = []
        this.total = 0
        this.totalMoney = '0.00'
      } finally {
        this.listLoading = false
      }
    },
    
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0]
        this.queryParams.endTime = dates[1]
      } else {
        this.queryParams.startTime = ''
        this.queryParams.endTime = ''
      }
    },

    setToday() {
      const today = new Date()
      const todayStr = this.formatDate(today)
      
      this.dateRange = [todayStr, todayStr]
      this.queryParams.startTime = todayStr
      this.queryParams.endTime = todayStr
      
      // 直接查询
      this.handleQuery()
    },

    setYesterday() {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      const yesterdayStr = this.formatDate(yesterday)
      
      this.dateRange = [yesterdayStr, yesterdayStr]
      this.queryParams.startTime = yesterdayStr
      this.queryParams.endTime = yesterdayStr
      
      // 直接查询
      this.handleQuery()
    },

    setLast7Days() {
      const end = new Date()
      const start = new Date()
      start.setDate(end.getDate() - 6) // 近7天包括今天
      
      this.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]
      
      this.queryParams.startTime = this.formatDate(start)
      this.queryParams.endTime = this.formatDate(end)
      
      // 直接查询
      this.handleQuery()
    },



    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    resetQuery() {
      this.dateRange = null
      this.queryParams = {
        page: 1,
        limit: 10,
        nickName: '',
        uid: '',
        relation_type: '',
        rechargeRecordType: 0,
        startTime: '',
        endTime: ''
      }
      this.getList()
    },
    
    getPayTypeLabel(payType) {
      const typeMap = {
        0: '支付宝',
        1: '微信',
        2: 'iOS',
        3: '后台充值',
        4: '公众号充值'
      }
      return typeMap[payType] || payType
    },

    getPayTypeTag(payType) {
      const tagMap = {
        0: 'primary',
        1: 'success',
        2: 'warning',
        3: 'info',
        4: 'success'
      }
      return tagMap[payType] || ''
    },
    
    getOperationLabel(payOperation) {
      const operationMap = {
        1: 'VIP充值',
        2: '购买金币',
        3: '购买礼包'
      }
      return operationMap[payOperation] || payOperation
    },
    
    getOperationTag(payOperation) {
      const tagMap = {
        1: 'danger',
        2: 'warning',
        3: 'info'
      }
      return tagMap[payOperation] || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-bar {
  display: flex;
  align-items: center;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 15px;

  .summary-item {
    font-size: 15px;
    color: #606266;
    font-weight: 600;

    .summary-amount {
      color: #67c23a;
      font-size: 20px;
      font-weight: bold;
      margin-left: 6px;
    }
  }

  .summary-tip {
    font-size: 12px;
    color: #909399;
    margin-left: 10px;
    font-weight: normal;
  }
}

.filter-container {
  padding-bottom: 10px;

  .filter-row {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
    vertical-align: top;

    .filter-label {
      display: inline-block;
      margin-right: 8px;
      min-width: 0;
      white-space: nowrap;
      vertical-align: middle;
    }

    .filter-item {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
    }
  }

  .button-row {
    display: inline-block;
    margin-right: 0;

    .filter-item {
      margin-right: 10px;
    }
  }
  
  // PC端样式
  .el-input {
    width: 200px;
  }
  
  .el-date-editor {
    width: 320px;
  }
}

.amount {
  color: #67c23a;
  font-weight: bold;
}

// 移动端适配
@media (max-width: 768px) {
  .filter-container {
    font-size: 12px;

    .filter-row {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      margin-bottom: 8px;
      white-space: nowrap;
      margin-right: 0;
      align-items: center;

      .filter-label {
        min-width: 50px;
        font-size: 12px;
        display: flex;
        align-items: center;
        height: 32px;
      }

      .filter-item {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }

    .el-input,
    .el-date-editor {
      width: 100% !important;
      min-width: 120px !important;
    }

    .button-row {
      display: flex;
      flex-wrap: wrap;

      .filter-item {
        flex: none;
        margin-right: 5px;
        margin-bottom: 5px;

        .el-button {
          padding: 4px 6px !important;
          font-size: 11px !important;
        }
      }
    }
  }

  // 表格适配
  .el-table {
    font-size: 12px;

    .el-table__cell {
      padding: 5px 2px;
    }
  }

  // 分页适配
  .pagination-container {
    text-align: center;

    .el-pagination {
      justify-content: center;

      .el-pagination__sizes,
      .el-pagination__jump {
        display: none;
      }
    }
  }
}

@media (max-width: 480px) {
  .filter-container {
    padding: 5px;
    font-size: 11px;

    .filter-row {
      .filter-label {
        min-width: 45px;
        font-size: 11px;
        height: 28px;
      }
    }

    .button-row {
      .el-button {
          padding: 8px 10px !important;
          font-size: 12px !important;
        }
    }
  }

  .el-table {
    font-size: 11px;

    .el-table__cell {
      padding: 3px 1px;
    }

    // 隐藏头像列在小屏幕上
    .el-table__header-wrapper,
    .el-table__body-wrapper {
      .el-table__row {

        td:nth-child(3),
        th:nth-child(3) {
          display: none;
        }
      }
    }
  }
}
</style>